export default __webpack_public_path__ + "static/media/google_avatar.ac23241d.svg";